import { lazyLoading } from "./libs/deferring";
import { simpleHeader } from "./partials/templates/header/simple-header.js";

document.addEventListener("DOMContentLoaded", () => {
    // Enable lazy loading
    lazyLoading();
});

simpleHeader();
